<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="1400"
    @keydown.esc="cancelButtonClickEvent"
    @close="cancelButtonClickEvent"
  >
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>排出事業者の検索</v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text class="px-2 card-layer" style="height: 70vh;max-height: 80vh;overflow-y: auto;">
        <v-row>
          <v-col>
            <!-- 検索ブロック -->
            <v-expansion-panels v-model="panel" accordion>
              <v-expansion-panel>
                <v-expansion-panel-header class="panel-header-color panel-selectable">
                  <strong>
                    <v-icon class="panel-header-color">
                      mdi-magnify
                    </v-icon>
                    &nbsp;条件を指定して検索
                  </strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card flat>
                    <v-card-text>
                      <!-- 検索範囲 -->
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-radio-group v-model="searchForm.mode" row dense hide-details="auto" label="検索範囲">
                            <v-radio v-for="n in modes" :key="n.value" :label="n.text" :value="n.value" />
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <!-- /検索範囲 -->
                      <v-row
                        v-if="searchForm.mode === 'emission'"
                      >
                        <v-col>
                          <v-text-field
                            v-model="searchForm.free_word"
                            dense
                            hide-details="auto"
                            label="排出事業者名称・事業場名称・事業者コード・事業場コード（空白区切り可）"
                            clearable
                            outlined
                            persistent-placeholder
                            placeholder="部分一致で検索"
                            ref="free_word"
                            rounded
                            @blur="searchEmissions"
                            @click:clear="searchForm.free_word = null; searchButtonClickEvent()"
                          />
                        </v-col>
                        <!-- 加入者番号 -->
                        <v-col v-if="searchForm.mode === 'emission'" cols="12" md="3">
                          <v-text-field v-model="searchForm.subscriberNo" dense hide-details="auto" label="加入者番号"
                                        clearable outlined persistent-placeholder placeholder="例）1234567" rounded @blur="searchEmissions"
                                        @click:clear="searchButtonClickEvent()" />
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-select v-model="searchForm.manifestType" :items="manifestTypes" dense hide-details="auto"
                                    label="マニフェスト区分" clearable outlined persistent-placeholder rounded @change="searchEmissions" />
                        </v-col>
                        <!-- /加入者番号 -->
                      </v-row>
                      <v-row>
                        <!-- 事業者コード -->
                        <v-col v-if="searchForm.mode === 'emissionLocation'" cols="12" md="3">
                          <v-text-field v-model="searchForm.code" dense hide-details="auto"
                                        :label="searchForm.mode === 'emission' ? '事業者コード' : '事業場コード'" clearable outlined
                                        persistent-placeholder placeholder="例）K001" rounded @blur="searchEmissions"
                                        @click:clear="searchForm.code = null; searchButtonClickEvent()" />
                        </v-col>
                        <!-- /事業者コード -->
                        <!-- 名称 -->
                        <v-col v-if="searchForm.mode === 'emissionLocation'" cols="12" md="3">
                          <v-text-field v-model="searchForm.name" dense hide-details="auto" label="名称" clearable outlined
                                        persistent-placeholder placeholder="部分一致で検索" rounded @blur="searchEmissions"
                                        @click:clear="searchForm.name = null; searchButtonClickEvent()" />
                        </v-col>
                        <!-- /名称 -->
                      </v-row>

                      <v-row>
                        <!-- /郵便番号 -->
                        <v-col cols="12" md="2">
                          <v-text-field v-model="searchForm.zipCode" dense label="郵便番号" hide-details="auto"
                                        hint="ハイフンを含めて入力してください" clearable outlined persistent-placeholder placeholder="例）111-1111"
                                        rounded @blur="searchEmissions" @click:clear="searchForm.zipCode = null; searchButtonClickEvent()">
                          </v-text-field>
                        </v-col>
                        <!-- 郵便番号 -->
                        <!-- 都道府県コードのみ -->
                        <v-col cols="12" md="2">
                          <v-autocomplete v-model="searchForm.prefectureCode" :items="prefList" clearable dense
                                          hide-details="auto" label="都道府県" outlined persistent-placeholder placeholder="例）東京都"
                                          rounded @change="searchEmissions" />
                        </v-col>
                        <!-- /都道府県コードのみ -->
                        <!-- 町域・詳細住所 -->
                        <v-col cols="12" md="5">
                          <v-text-field v-model="searchForm.address" dense label="市区町村・町域・詳細住所" hide-details="auto"
                                        clearable outlined persistent-placeholder placeholder="例）中央区日本橋兜町１－２－３○○ビル○階" rounded @blur="searchEmissions"
                                        @click:clear="searchForm.address = null; searchButtonClickEvent()"/>
                        </v-col>
                        <!-- /町域・詳細住所 -->
                        <!-- 電話番号 -->
                        <v-col cols="12" md="3">
                          <v-text-field v-model="searchForm.phoneNumber" autocomplete="off" dense
                                        hint="電話番号を「-」ハイフン「( )」込みで入力します" hide-details="auto" label="電話番号" clearable outlined
                                        persistent-placeholder placeholder="例）000-0000-0000" persistent-hint rounded @blur="searchEmissions"
                                        @click:clear="searchForm.phoneNumber = null; searchButtonClickEvent()" />
                        </v-col>
                        <!-- /電話番号 -->
                      </v-row>

                      <v-row>
                        <!-- 事業者メモ -->
                        <v-col cols="12" md="3">
                          <v-text-field v-model="searchForm.memo" dense hide-details="auto"
                                        :label="searchForm.mode === 'emission' ? '事業者メモ' : '事業場メモ'" clearable outlined
                                        persistent-placeholder rounded persistent-hint @blur="searchEmissions"
                                        @click:clear="searchForm.memo = null; searchButtonClickEvent()" />
                        </v-col>
                        <!-- /事業者メモ -->
                      </v-row>


                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="primary" @click="searchAndClosePanel">
                        検索
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- /検索ブロック -->
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
              <v-data-table
                :headers="tableHeaders"
                :items="emissions"
                :items-per-page="-1"
                item-key="key"
                disable-sort
                hide-default-footer
                single-select
                @click:row="rowClickEvent"
                @dblclick:row="rowDoubleClickEvent"
              >
                <!-- 排出事業者・排出事業者コード -->
                <template v-slot:[`item.name`]="{ item }">
                  <div
                    :class="item.disabled ? 'text--disabled' : ''"
                  >
                    <small>{{ item.name }}</small>
                    <v-tooltip top :open-on-hover="false">
                      <template #activator="{ on }">
                        <v-btn icon tile x-small retain-focus-on-click @click="on.click" @blur="on.blur">
                          <v-icon small>mdi-map-marker-outline</v-icon>
                        </v-btn>
                      </template>
                      <div>
                        <small>〒{{ item.zip_code }}<br />{{ item.address }}</small>
                      </div>
                    </v-tooltip>
                  </div>

                  <div
                    :class="item.disabled ? 'text--disabled' : ''"
                  >
                    <small>{{ item.code}}</small>
                  </div>
                </template>
                <!-- /排出事業者・排出事業者コード -->

                <!-- 排出事業場・排出事業場コード -->
                <template v-slot:[`item.location.name`]="{ item }">
                  <div
                    :class="item.disabled ? 'text--disabled' : ''"
                  >
                    <small>{{ item.location.name }}</small>
                  </div>
                  <div
                    :class="item.disabled ? 'text--disabled' : ''"
                  >
                    <small>{{ item.location.code}}</small>
                  </div>
                </template>
                <!-- /排出事業場・排出事業場コード -->

                <!-- 排出事業者メモ・排出事業場メモ -->
                <template v-slot:[`item.memo`]="{ item }">
                  <div>
                    <!-- 排出事業者メモ（上段固定） -->
                    <div
                      :class="item.disabled ? 'text--disabled' : ''"
                      style="min-height: 20px; margin-bottom: 2px;"
                    >
                      <div class="inline-flex-container">
                        <div
                          :title="item.memo"
                          class="line-clamp one-clamp"
                        >
                          {{ item.memo }}
                        </div>
                        <v-tooltip
                          v-if="item.memo"
                          top :open-on-hover="false"
                        >
                          <template #activator="{ on }">
                            <v-btn icon tile x-small retain-focus-on-click class="map-icon" @click="on.click" @blur="on.blur">
                              <v-icon small>mdi-tooltip-outline</v-icon>
                            </v-btn>
                          </template>
                          <div>
                            <small>{{ item.memo }}</small>
                          </div>
                        </v-tooltip>
                      </div>
                    </div>
                    <!-- 排出事業場メモ（下段固定） -->
                    <div
                      :class="item.disabled ? 'text--disabled' : ''"
                      style="min-height: 20px;"
                    >
                      <div class="inline-flex-container">
                        <div
                          :title="item.location.memo"
                          class="line-clamp one-clamp"
                        >
                          {{ item.location.memo }}
                        </div>
                        <v-tooltip
                          v-if="item.location.memo"
                          top :open-on-hover="false"
                        >
                          <template #activator="{ on }">
                            <v-btn icon tile x-small retain-focus-on-click class="map-icon" @click="on.click" @blur="on.blur">
                              <v-icon small>mdi-tooltip-outline</v-icon>
                            </v-btn>
                          </template>
                          <div>
                            <small>{{ item.location.memo }}</small>
                          </div>
                        </v-tooltip>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- /排出事業者メモ・排出事業場メモ -->

                <!-- 排出事業場住所 -->
                <template v-slot:[`item.location.address`]="{ item }">
                  <div
                    :class="item.disabled ? 'text--disabled' : ''"
                  >
                    <small>
                      〒{{ item.location.zip_code }}
                    </small>
                    <div
                      :title="item.location.address"
                      class="line-clamp one-clamp"
                    >
                      {{ item.location.address }}
                    </div>
                  </div>
                </template>
                <!-- /排出事業場住所 -->

                <!-- 請求先・排出事業場メモ -->
                <template v-slot:[`item.billing_address_name`]="{ item }">
                  <div
                    v-if="item.billing_address"
                    :class="item.disabled ? 'text--disabled' : ''"
                  >
                    <div
                      :title="item.billing_address.name"
                      class="line-clamp one-clamp"
                    >
                      {{ item.billing_address.name }}
                    </div>
                  </div>
                  <div
                    v-if="item.billing_address"
                    :class="item.disabled ? 'text--disabled' : ''"
                  >
                    <div class="inline-flex-container">
                      <div
                        :title="item.billing_address_memo"
                        class="line-clamp one-clamp"
                      >
                        {{ item.billing_address_memo }}
                      </div>
                      <v-tooltip
                        v-if="item.billing_address_memo"
                        top :open-on-hover="false"
                      >
                        <template #activator="{ on }">
                          <v-btn icon tile x-small retain-focus-on-click class="map-icon" @click="on.click" @blur="on.blur">
                            <v-icon small>mdi-tooltip-outline</v-icon>
                          </v-btn>
                        </template>
                        <div>
                          <small>{{ item.billing_address_memo }}</small>
                        </div>
                      </v-tooltip>
                    </div>
                  </div>
                </template>
                <!-- /請求先・排出事業場メモ -->

                <template v-slot:[`item.manifest_type`]="{ item }">
                  {{ item.manifest_type | manifest_type_to_label }}
                </template>
              </v-data-table>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-pagination v-model="page" :length="pagination.total_pages" :total-visible="totalVisible" circle
                          prev-icon="mdi-menu-left" next-icon="mdi-menu-right" @input="pageChangeEvent" />
          </v-col>
        </v-row>

      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="cancelButtonClickEvent" @mousedown.prevent>
          閉じる
        </v-btn>
        <v-btn color="primary" :disabled="!selectedItem" @click="registerButtonClickEvent">
          反映
        </v-btn>
        <v-snackbar v-model="snackbar" color="red accent-2" :timeout="timeout">
          {{ message }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PrefectureList from "../../../mixins/PrefectureList"

export default {
  name: 'SearchEmissionDialog',
  components: {},
  mixins: [PrefectureList],
  props: {
    /**
     * ダイアログの表示/非表示を制御します。
     * @type {boolean}
     * @default false
     */
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    /**
     * 検索対象のフィルタを指定します。
     * - 'all': すべて
     * - 'exclude_general': 一般を除く
     * @type {'all'|'exclude_general'}
     * @default 'all'
     */
    emissionFilter: {
      type: String,
      default: () => 'all',
      validator: function (value) {
        return ['all', 'exclude_general'].includes(value)
      }
    },
  },
  data() {
    return {
      panel: [],
      page: 1,
      totalVisible: 7,
      emissions: [],
      selectedItem: null,
      selectedRow: null,
      tableHeaders: [
      ],
      searchForm: {
        mode: "emission",
        free_word: null,
        code: null,
        subscriberNo: null,
        name: null,
        zipCode: null,
        prefectureCode: null,
        address: null,
        manifestType: null,
        phoneNumber: null,
        memo: null,
        location_code: null,
        location_name: null,
      },
      modes: [
        { value: "emission", text: "排出事業者" },
        { value: "emissionLocation", text: "排出事業場" },
      ],
      pagination: {
        current_page: 1,
        total_count: 0
      },
      snackbar: false,
      message: null,
      timeout: 5000,
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      useBilling: 'use_billing',
    }),
    manifestTypes() {
      const allTypes = [
        { value: 'dxe_form', text: '電子マニフェスト(EDI)' },
        { value: 'other_form', text: '電子マニフェスト(WEB)' },
        { value: 'paper_form', text: '紙マニフェスト' },
        { value: 'general_form', text: '一般廃棄物' }
      ]

      if (this.emissionFilter === 'exclude_general') {
        return allTypes.filter(type => type.value !== 'general_form')
      }

      return allTypes
    },
  },
  watch: {
    useBilling(newValue) {
      this.setTableHeader(newValue)
    },
    enableDialog(value) {
      // 検索パネルを開いた状態にする.
      this.panel = 0
      this.scrollToTop()
      this.emissions = []
      this.page = 1
      Object.assign(this.$data.searchForm, this.$options.data().searchForm)
      Object.assign(this.$data.pagination, this.$options.data().pagination)
      this.setTableHeader(this.useBilling)
      if (this.selectedRow) {
        this.selectedRow.select(false)
      }
      this.selectedItem = null
    },
  },
  created() { },
  methods: {
    ...mapActions('DriverMasterSearchEmissionDetail', {
      fetchEmissionDetails: 'index',
    }),
    ...mapActions('DriverMasterSearchJipCode', {
      fetchJipCode: 'show'
    }),
    setTableHeader(newValue) {
      let table_headers = [
        { text: '排出事業者\r\n事業者コード', value: 'name' },
        { text: '排出事業場\r\n事業場コード', value: 'location.name' },
        { text: '事業者メモ\r\n事業場メモ', value: 'memo' },
        { text: '事業場住所', value: 'location.address' },
        { text: 'マニフェスト区分', value: 'manifest_type' }
      ]
      if (newValue) {
        table_headers.push({ text: '請求先\r\n請求先メモ', value: 'billing_address_name' })
      }
      this.tableHeaders = table_headers
    },
    pageChangeEvent() {
      this.searchEmissions()
    },
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent() {
      this.page = 1
      this.searchEmissions()
    },
    /**
     * キャンセルボタン クリックイベント
     */
    cancelButtonClickEvent() {
      this.$emit('cancelCallback')
    },
    registerButtonClickEvent() {
      let params = this.buildCheckParam()
      this.fetchJipCode({ params: params }).then((content) => {
        if (content.message) {
          this.message = content.message
          this.snackbar = true
        } else {
          this.$emit('registerCallback', this.selectedItem)
        }
      })
    },
    buildCheckParam() {
      return {
        zip_code: this.selectedItem.zip_code,
        prefecture_code: this.selectedItem.prefecture_code,
        address_1: this.selectedItem.address_1,
        location_zip_code: this.selectedItem.location.zip_code,
        location_prefecture_code: this.selectedItem.location.prefecture_code,
        location_address_1: this.selectedItem.location.address_1,
      }
    },
    /**
     * 排出事業者　行選択イベント
     * @param item 
     * @param row 
     */
    rowClickEvent(item, row) {
      if (item.disabled) {
        if (this.selectedRow) {
          this.selectedRow.select(false)
          this.selectedRow = null
          this.selectedItem = null
        }
        return false
      }
      this.selectedItem = item
      this.selectedRow = row
      row.select(true)
    },
    /**
     * 排出事業者　行反映ダブルクリックイベント
     * @param $event { MouseEvent }
     * @param row { Object } 行
     */
    rowDoubleClickEvent($event, row) {
      this.$emit("registerCallback", row.item);
    },
    searchEmissions() {
      if (!this.enableDialog) return false;

      let params = this.buildParam()
      this.fetchEmissionDetails({ params: params }).then((content) => {
        this.scrollToTop()
        this.emissions = content.emissions;
        this.pagination = content.pagination;
      });
    },
    searchAndClosePanel() {
      let params = this.buildParam()
      this.fetchEmissionDetails({ params: params }).then((content) => {
        this.scrollToTop()
        this.panel = []
        this.emissions = content.emissions
        this.pagination = content.pagination
      })
    },
    buildParam() {
      return {
        /* 検索範囲 */
        mode: this.searchForm.mode,
        /* 排出事業者名称, 排出事業場名称, 排出事業者コード, 排出事業場コード(排出事業者のみ) */
        free_word: this.searchForm.mode === 'emission' ? this.searchForm.free_word : null,
        /* コード(排出事業場のみ) */
        code: this.searchForm.mode === 'emission' ? null : this.searchForm.code,
        /* 加入者番号(排出事業者のみ) */
        subscriber_no: this.searchForm.mode === 'emission' ? this.searchForm.subscriberNo : null,
        /* 名称(排出事業場のみ) */
        name: this.searchForm.mode === 'emission' ? null : this.searchForm.name,
        /* 郵便番号 */
        zip_code: this.searchForm.zipCode,
        /* 都道府県コード */
        prefecture_code: this.searchForm.prefectureCode,
        /* 住所 */
        address: this.searchForm.address,
        /* 電話番号 */
        phone_number: this.searchForm.phoneNumber,
        /* マニフェスト区分 */
        manifest_type: this.searchForm.manifestType,
        /* メモ */
        memo: this.searchForm.memo,

        without_invisible: true,
        emission_filter: this.emissionFilter,
        page: this.page
      }
    },
    scrollToTop() {
      const elements = document.getElementsByClassName('v-dialog--active')
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      const cards = elements[0].getElementsByClassName('card-layer')
      if (!cards || !cards.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      cards[0].scrollTop = 0;
    },
  }
}
</script>

<style scoped lang="scss">
.inline-flex-container {
  display: inline-flex;
  align-items: center;
  gap: 0;
  max-width: 100%;
}
.map-icon {
  flex-shrink: 0;
}
</style>
